export type PublicConfig = {
  clerkPublishableKey: string;
  clerkJwtTemplate: string;
  relayUrl: string | null;
  relayConfigured: boolean;
  commitSha: string | null;
};

function required(name: string, value: string | undefined): string {
  const trimmed = value?.trim() ?? "";
  if (!trimmed) throw new Error(`${name} is not configured.`);
  return trimmed;
}

export function readPublicConfig(): PublicConfig {
  const rawRelayUrl = import.meta.env.VITE_CODESSA_RELAY_URL?.trim() ?? "";
  const relayUrl = rawRelayUrl ? rawRelayUrl.replace(/\/$/, "") : null;

  return {
    clerkPublishableKey: required(
      "VITE_CLERK_PUBLISHABLE_KEY",
      import.meta.env.VITE_CLERK_PUBLISHABLE_KEY,
    ),
    clerkJwtTemplate: required(
      "VITE_CLERK_JWT_TEMPLATE",
      import.meta.env.VITE_CLERK_JWT_TEMPLATE,
    ),
    relayUrl,
    relayConfigured: relayUrl !== null,
    commitSha: import.meta.env.VITE_COMMIT_SHA?.trim() || null,
  };
}

export function isProductionBuild(): boolean {
  return import.meta.env.PROD;
}
